import {Text} from '../../text'

const inlineStyle = {fontVariant: 'all-small-caps', marginRight: 4}

export const FiltersLabel = () => {
	return <Text t="filters.label" small bold color="dark-grey" noTextSelect style={inlineStyle} />
}
